import { connect } from "react-redux";

import { formSaveAction } from "../../../../Engine/ActionCreators/FormActionCreators";
import { CandyDispatch } from "../../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";

import { FormSaveStatus } from "./FormSaveStatus";

const mapStateToProps = (state: FullFormState) => ({ status: state.formVisualState.savingStatus });

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onSaveForm: () => dispatch(formSaveAction),
});

export const FormSaveStatusContainer = connect(mapStateToProps, mapDispatchToProps)(FormSaveStatus);
